export const getPositionValues = (columnIndex, totalColumns) => {
  return columnIndex + 1 > totalColumns - 3
    ? { rightValue: '100%' }
    : { leftValue: '100%' };
};
